// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { SectionOut } from './sectionOut.zod.ts';

export const SectionSaveOut = zod.object({
  "revision": zod.int(),
  "section": SectionOut,
  "warnings": zod.array(zod.string())
});

export type SectionSaveOut = zod.input<typeof SectionSaveOut>;
export type SectionSaveOutOutput = zod.output<typeof SectionSaveOut>;
